document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.zoy-ob-section');
  
  sections.forEach(section => {
    const scrollContainer = section.querySelector('.zoy-ob-grid');
    const dots = section.querySelectorAll('.zoy-ob-dot');
    
    if (scrollContainer && dots.length > 0) {
      scrollContainer.addEventListener('scroll', function() {
        // Calculate which card is closest to the center of the viewport
        const scrollPosition = scrollContainer.scrollLeft;
        const containerWidth = scrollContainer.offsetWidth;
        const centerPosition = scrollPosition + (containerWidth / 2);
        
        let activeIndex = 0;
        let minDistance = Infinity;

        Array.from(scrollContainer.children).forEach((card, index) => {
          const cardCenter = card.offsetLeft + (card.offsetWidth / 2);
          const distance = Math.abs(centerPosition - cardCenter);
          
          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = index;
          }
        });
        
        dots.forEach((dot, index) => {
          if(index === activeIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      });
    }
  });
});
